/**
 * @generated SignedSource<<e9d8152ad26dc8ffcb9d11be90ab015f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SudoTriggerClientUpdateMutationInput = {
  clientMutationId?: string | null;
  force: boolean;
};
export type SudoTriggerClientUpdateMutation$variables = {
  input: SudoTriggerClientUpdateMutationInput;
};
export type SudoTriggerClientUpdateMutation$data = {
  readonly sudoTriggerClientUpdate: {
    readonly clientMutationId: string | null;
    readonly sudo: {
      readonly id: string;
      readonly chromeAppUpdateTimes: {
        readonly idleTime: any | null;
        readonly forceTime: any | null;
      } | null;
    } | null;
  } | null;
};
export type SudoTriggerClientUpdateMutation = {
  variables: SudoTriggerClientUpdateMutation$variables;
  response: SudoTriggerClientUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SudoTriggerClientUpdateMutationPayload",
    "kind": "LinkedField",
    "name": "sudoTriggerClientUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Sudo",
        "kind": "LinkedField",
        "name": "sudo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChromeAppUpdateTimes",
            "kind": "LinkedField",
            "name": "chromeAppUpdateTimes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "idleTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forceTime",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SudoTriggerClientUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SudoTriggerClientUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "358b33f2eb39e0b1e29937f2b8eedd46",
    "id": null,
    "metadata": {},
    "name": "SudoTriggerClientUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation SudoTriggerClientUpdateMutation(\n  $input: SudoTriggerClientUpdateMutationInput!\n) {\n  sudoTriggerClientUpdate(input: $input) {\n    clientMutationId\n    sudo {\n      id\n      chromeAppUpdateTimes {\n        idleTime\n        forceTime\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ead9cda81cdc892f9aa2ab64fe24c01";

export default node;
